import { ActionTypes } from './action-types';

export enum AUTHENTICATION_STATE {
    LOGGED_IN,
    LOGIN_FAILED,
    LOGIN_PROMPTED,
    VERIFYING,
    LOGGED_OUT,
}

export interface ISession {
  id?: string
  idp?: {
    accessToken?: string,
    idToken?: string
  }
  user: IUser
}

export interface ISessionHolder {
  session: ISession
  state: AUTHENTICATION_STATE
}

export interface IUser {
  id: string
  email: string
  date?: string,
  firstName?: string,
  lastName?: string,
  isConfirmed?: boolean,
  currentDeviceId?: string,
  isPending?: boolean,
}

export type ActionObject =
    {
        type: ActionTypes.USER_LOGIN_FAILURE
    } | {
        type: ActionTypes.USER_LOGIN_REQUEST
    } | {
        type: ActionTypes.USER_LOGIN_SUCCESS,
        session: ISession
    } | {
        type: ActionTypes.USER_LOGOUT_SUCCESS
    } | {
        type: ActionTypes.USER_LOGIN_VERIFYING
    }



// WEBPACK FOOTER //
// ./src/types/authentication.ts